<div class="my-8 flex">
  <button class="ic-btn-primary" (routerLink)="(routerLink)">
    <mat-icon>keyboard_arrow_left</mat-icon>
    <span> {{ 'COMPONENTS.HEAD_DETAIL.buttonPrevious' | translate }} </span>
  </button>

  <span class="ic-head-detail__label ml-8">{{ label }}</span>
</div>
